import NextArrow from '../../assets/Icons/right-arrow.png';
import LeftArrow from '../../assets/Icons/left-arrow.png';
import styles from './Pagination.module.scss';

type CustomPaginationProps = {
  pageCount: number,
  currentPage: number,
  onPageChange: (newPage: number) => void;
}

const getPageNumbersToDisplay = (currentPage: number, pageCount: number) => {
  const pageNumbersToDisplay = 7;
  const pageNumbers = new Set<number>();
  pageNumbers.add(0);
  pageNumbers.add(pageCount - 1);

  for (let i = Math.max(0, currentPage - 2); i <= currentPage; i++) {
    pageNumbers.add(i);
  }

  for (let i = currentPage + 1; pageNumbers.size < pageNumbersToDisplay && i < pageCount; i++) {
    pageNumbers.add(i);
  }

  for (let i = Math.max(0, currentPage - 2) - 1; i >= 0 && pageNumbers.size < pageNumbersToDisplay; i--) {
    pageNumbers.add(i);
  }

  return [... new Set(pageNumbers)].sort((a, b) => a -b)
}

const CustomPagination = (props: CustomPaginationProps) => {
  const { pageCount, currentPage, onPageChange } = props;

  const handlePageClick = (selected: number ) => {
    onPageChange(selected);
  };

  const pageNumbers = getPageNumbersToDisplay(currentPage, pageCount);

  return (
    <div className={styles.Pagination}>
      <img src={LeftArrow} alt="Previous Icons" onClick={() => handlePageClick(Math.max(currentPage - 1, 0))} />
      {
        pageNumbers.map((num) => (
          <p key={num} onClick={() => handlePageClick(num)} className={num === currentPage ? styles.active : ''}>{num + 1}</p>
        ))
      }
      <img src={NextArrow} alt="Next Icons" onClick={() => handlePageClick(Math.min(currentPage + 1, pageCount - 1))} />
    </div>
  )
};

export default CustomPagination;